import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['edit_form', 'slider'];

  updateAutoRenew() {
    this.sliderTarget.disabled = true;
    this.edit_formTarget.submit();
  }
}
